import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import { authServices } from '../services/auth.service';

export const useDeletePhoto = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (adminId) => {
      return authServices.deleteProfilePhoto(adminId);
    },
    onSuccess: () => {
      toast.success('Profile photo deleted successfully');
      queryClient.invalidateQueries({ queryKey: ['user-profile'] });
    },
    onError: (error) => {
      const message = error?.response?.data?.message || error?.message || 'Failed to delete photo';
      toast.error(message);
    },
  });
};
